<template>
  <section class="section-hero section-shaped my-0">
    <div class="shape shape-style-1 shape-primary">
      <img src="img/bk.jpg" class="img-fill" />
      <span class="span-150"></span>
      <span class="span-50"></span>
      <span class="span-50"></span>
      <span class="span-75"></span>
      <span class="span-100"></span>
      <span class="span-75"></span>
      <span class="span-50"></span>
      <span class="span-100"></span>
      <span class="span-50"></span>
      <span class="span-100"></span>
    </div>
    <div class="container shape-container d-flex align-items-center">
      <div class="col px-0">
        <div class="row justify-content-center align-items-center">
          <div class="text-center">
            <img src="img/brand/logo_white.png" class="img-fluid" />
            <h1
              class="font-weight-semibold ls4 text-uppercase text-white bottommargin-sm"
              style="font-size: 80px;"
            >Match. Meet. Sell.</h1>

            <b-spinner style="width: 3rem; height: 3rem;"></b-spinner>
            <h3
              class="mt-5 mb-5 text-white"
              style="color: dark-gray;"
            >By clicking Sign Up, you agree to our Terms. Learn how we process your data in our Privacy Policy and Cookie Policy.</h3>

            <div class="btn-wrapper">
              <b-button v-b-modal.signup_modal variant="info" size="lg" class="mb-3">
                <b-icon icon="person-fill"></b-icon>Sign Up
              </b-button>

              <b-modal
                id="signup_modal"
                header-class="text-center"
                title-class="title-fill"
                hide-footer
                hide-backdrop
              >
                <template v-slot:modal-title>
                  <img src="img/brand/logo.png" style="width:110px; height:110px;" />
                  <h2 style="font-style: italic;">GET STARTED</h2>
                </template>
                <template>
                  <span
                    class="text-muted text-center"
                  >By clicking Log In, you agree to our Terms. Learn how we process your data in our Privacy Policy, and Cookie Policy</span>
                  <div class="text-muted text-center mb-3 mt-4">
                    <base-button block type="neutral" @click="SignupGoogle()">
                      <img slot="icon" src="img/icons/common/google.svg" />
                      Google Signup
                    </base-button>
                  </div>
                  <div class="text-muted text-center mb-3">
                    <base-button block type="neutral" @click="SignupLinkedIn()">
                      <img slot="icon" src="img/icons/common/linkedin.png" />
                      LinkedIn Signup
                    </base-button>
                  </div>
                  <div class="text-muted text-center mb-3">
                    <base-button block type="neutral" @click="SignupPhone()">
                      <img slot="icon" src="img/icons/common/phone.png" />
                      Phone Signup
                    </base-button>
                  </div>
                  <div class="text-muted text-center mb-3">
                    <base-button block type="neutral" @click="SignupEmail()">
                      <img slot="icon" src="img/icons/common/email.png" />
                      Email Signup
                    </base-button>
                  </div>
                </template>
                <template>
                  <div class="bottom_app_sect text-center">
                    <h4 class="mt-3" style="font-style: italic; ">Get the App!</h4>

                    <div class="row">
                      <div class="col">
                        <b-button block class="mb-3" type="neutral" @click="GotoAppStore()">
                          <img slot="icon" src="img/brand/apple.png" />
                        </b-button>
                      </div>
                      <div class="col">
                        <b-button block class="mb-3" type="neutral" @click="GotoGoogleStore()">
                          <img slot="icon" src="img/brand/web_android.png" />
                        </b-button>
                      </div>
                    </div>
                  </div>
                </template>
              </b-modal>
            </div>
            <!-- <div class="btn-wrapper">
              <base-button
                tag="a"
                class="mb-3 mb-sm-0"
                type="info"
                icon="fa fa-code"
                @click="SignupPhone()"
              >Sign UP with Phone</base-button>
            </div>-->
          </div>
        </div>
        <div class="row align-items-center justify-content-around stars-and-coded">
          <div class="col-sm-4">
            <!-- <span class="text-white alpha-7 ml-3">Star us on</span>
                        <a href="https://github.com/creativetimofficial/argon-design-system" target="_blank" title="Support us on Github">
                            <img src="img/brand/github-white-slim.png" style="height: 22px; margin-top: -3px">
            </a>-->
          </div>
          <div class="col-sm-4 mt-4 mt-sm-0 text-right">
            <!-- <span class="text-white alpha-7">Coded by</span>
                        <a href="https://www.creative-tim.com" target="_blank" title="Creative Tim - Premium Bootstrap Themes and Templates">
                            <img src="img/brand/creativetim-white-slim.png" class="ml-3" style="height: 30px;">
            </a>-->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Modal from "@/components/Modal.vue";
const axios = require("axios");
export default {
  name: "components",
  components: {
    Modal,
  },
  mounted() {},
  data() {
    return {
      signup_modal: false,
      formatted_phone_number: "",
    };
  },
  methods: {
    async googleSign() {
      // const authCode = await this.$gAuth.getAuthCode();
      //   console.log(authCode);
      // const response = axios.post('http://135.181.29.143:4040/api/googlesign/google');
    },
    SignupGoogle() {
      // axios.get("http://zorion.alpha-innomed.com:4040/api/googlesign/google")
      this.$store.dispatch("storeSignupType", 'google');
      // this.$store.dispatch("storeUser", resp.data.user);
      // this.$router.push({ name: "account" });
      window.location.href =
        "http://zorion.alpha-innomed.com:4040/api/googlesign/google";
    },
    SignupLinkedIn() {
      // axios
      //   .get("http://zorion.alpha-innomed.com:4040/api/linkedinsign/linkedin")
      //   .then(function (response) {
      //     // handle success
      //     console.log(response);
      //   })
      //   .catch(function (error) {
      //     // handle error
      //     console.log(error);
      //   })
      //   .then(function () {
      //     // always executed
      //   });
      this.$store.dispatch("storeSignupType", 'linkedin');
      window.location.href =
        "http://zorion.alpha-innomed.com:4040/api/linkedinsign/linkedin";
    },
    SignupPhone() {
      window.location.href = "#/phonesignup";
    },
    SignupEmail() {
      this.$store.dispatch("storeSignupType", 'email');
      window.location.href = "#/account";
    },
    // SignupPhone() {
    //   window.location.href = "#/signupphone";
    //
    // },
  },
};
</script>
<style>
.img-fill {
  min-width: 100% !important;
  height: 100% !important;
}
.title-fill {
  width: 100%;
}
.footer-fill {
  display: block !important;
}
.bottom_app_sect {
  border-top: 1px solid #e9ecef;
}
</style>
